import React from 'react';
import { BaseProductCard } from './BaseProductCard';

interface ProductCardProps {
  productId: string;
  cardIndex?: number;
}

export const ProductCard = ({ productId, cardIndex }: ProductCardProps) => {
  return <BaseProductCard productId={productId} cardIndex={cardIndex} />;
};
